import { render } from "./CrStepSurface5Content.vue?vue&type=template&id=70b34847&scoped=true"
import script from "./CrStepSurface5Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface5Content.vue?vue&type=script&lang=js"

import "./CrStepSurface5Content.vue?vue&type=style&index=0&id=70b34847&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b34847"]])

export default __exports__